<template>

<div class="shell">

	<main class="shell-main">
		<router-view />
	</main>

</div>

</template>

<script>

export default {
	name: 'App'
}

</script>

<style scoped>

.shell {
	min-height: 100%;
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	padding: 32px 18px 18px;
	background: var(--bg);
}

.shell-main {
	width: 100%;
	flex: 1;
	display: flex;
	justify-content: center;
	align-items: center;
}

</style>
